import { MediaManagerModule } from "./../modules/shared/media/media-manager/media-manager.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { NewMediaRoutingModule } from "./new-media-routing.module";
import { NewMediaManagerComponent } from "./new-media-manager/new-media-manager.component";
import { ListComponent } from "./new-media-manager/list/list.component";
import { MaterialUtilitiesModule } from "../modules/shared/material-utilities/material-utilities.module";
import { NgxBootstrapModule } from "../modules/shared/ngx-bootstrap/ngx-bootstrap.module";
import { NgxUtilitiesModule } from "../modules/shared/ngx-utilities/ngx-utilities.module";
import { FoldersComponent } from "./new-media-manager/folders/folders.component";
import { AddEditFolderComponent } from "./new-media-manager/folders/add-edit-folder/add-edit-folder.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SubFoldersComponent } from "./new-media-manager/folders/sub-folders/sub-folders.component";
import { MediaFoldersComponent } from "./new-media-manager/media-folders/media-folders.component";
import { ManageMediaComponent } from "./new-media-manager/media-folders/manage-media/manage-media.component";
// import { PreviewComponent } from "./new-media-manager/media-folders/manage-media/preview/preview.component";
import { DetailsComponent } from "./new-media-manager/media-folders/manage-media/details/details.component";
import { MetaComponent } from "./new-media-manager/media-folders/manage-media/meta/meta.component";
import { UpdateComponent } from "./new-media-manager/media-folders/manage-media/update/update.component";
import { SearchPipe } from "./common/filter.pipe";
import { MediaDialogComponent } from "./new-media-manager/media-dialog/media-dialog.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { OtherUtilitiesModule } from "../modules/shared/other-utilities/other-utilities.module";
import { MediaUploadDialogComponent } from "./new-media-manager/media-upload-dialog/media-upload-dialog.component";
import { MoveDialogComponent } from "./new-media-manager/media-folders/manage-media/move-dialog/move-dialog.component";
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    NewMediaManagerComponent,
    ListComponent,
    FoldersComponent,
    // PreviewComponent,
    MediaUploadDialogComponent,
    MoveDialogComponent,
    // AddEditFolderComponent,
    // SubFoldersComponent, 
    // MediaFoldersComponent,
    // ManageMediaComponent,
    // PreviewComponent,
    // DetailsComponent,
    // MetaComponent,
    // UpdateComponent,
    SearchPipe,

    //  MediaDialogComponent
  ],
  imports: [
    OtherUtilitiesModule,
    CommonModule,
    NewMediaRoutingModule,
    NgxBootstrapModule,
    NgxUtilitiesModule,
    MaterialUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    MediaManagerModule,
    BsDropdownModule,
    DragDropModule,
  ],
  exports: [SearchPipe],
  // entryComponents: [
  //   MediaDialogComponent,
  //   MediaUploadDialogComponent,
  //   MoveDialogComponent,
  // ],
})
export class NewMediaModule {}
